
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners-page",
      function () {
        return require("private-next-pages/partners-page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners-page"])
      });
    }
  